import React from "react";

/* eslint-disable */
import Header from "../../header";
import Banner from ".././Banner";
import SubNav from ".././SubNav";
import Footer from "../../Footer";

const icon = require("../../../assets/Detasad Cloud/main_icon_highperformance.svg");

const CloudEmailArchive = () => {
    const heading = `CLOUD EMAIL ARCHIVE`;
    const details = `Get the flexibility and operational efficiency to meet compliance requirements with our Cloud Email Archive service.`;

    const overview = [
        `Usually the business-critical information is located in company email systems and sometimes its stored only there. That makes it more important than ever to have email archiving software in order to ensure business continuity and information availability. This is where DETASAD  Email Archive service becomes important.`,
        `Our enterprise-grade and integrated email archiving solution helps you proactively comply with the regulatory, legal and business requirements for your data. DETASAD  Email Archiving solution also helps in improving the operational efficiency of your email environment, including cloud email solutions like Microsoft Office 365, even as email volumes continue to grow.`
    ];

    const advantages = [
        [
            `eDiscovery and Compliance Made Easy`,
            `DETASADs email archiving solution provides the flexibility and operational efficiency to meet regulatory, compliance and business requirements.`,
            icon
        ],
        [
            `Cost & Risk Effective`,
            `DETASAD  helps cut the cost, risk and complexity of email archiving with its enterprise-grade archiving solution which can handle your ever-increasing email data volume.`,
            icon
        ],
        [
            `Designed for Cloud Emails`,
            `Our comprehensive solution enhances your ability to archive email data efficiently and meet stringent regulatory and compliance requirements. `,
            icon
        ],
        [`Secure`, `DETASAD ensures that the archived data in the emails is fortified and well-protected.`, icon]
    ];

    return (
        <div>
            <Header />
            <Banner heading={heading} details={details} className="bg-collab"/>
            <SubNav overview={overview} advantages={advantages} />
            <Footer />
        </div>
    );
};

export default CloudEmailArchive;
